import { IRotaManagementRotaCreatePropsData, IRotaManagementShiftListData } from "@/api_framework/api_modals/Rota";
import NonSearchableSelectMenu from "@/app/components/ui/SelectMenus/NonSearchableSelectMenu/index";
import { ISelectMenuItemData } from "@/app/components/ui/interface";
import { useRotaCreateAPI } from "@/app/hooks/api_hooks/Rota/useRotaCreateAPI";
import { useRotaErrorListAPI } from "@/app/hooks/api_hooks/Rota/useRotaErrorListAPI";
import { useRotaShiftCreateAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftCreateAPI";
import { useRotaShiftFilterAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftFilterAPI";
import { useRotaShiftNameAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftNameAPI";
import { useAfterFirstRender } from "@/app/hooks/useAfterFirstRender";
import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useSelectMenuReducer } from "@/app/hooks/useSelectMenuReducer";
import { IRotaState } from "@/app_redux/reducers/slices/auth/rota_slice";
import { Dialog, Transition } from "@headlessui/react";
import { PlusIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Fragment, useEffect, useRef, useState } from "react";
import { BiLoaderAlt } from "react-icons/bi";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import ShiftBreakComponent from "../../AddNewShiftComponent/ShiftBreakComponent";
import { IRotaAddModalProps } from "../../interface";
import { IClickLogBody, useClickLogAPI } from "@/app/hooks/api_hooks/org/useClickLogAPI";
import { useAppSelector } from "@/app_redux/hooks/root_hook";

export interface IBookingCommentsFormFields {
  shift: string;
  date: string;
  startTimeHour: string;
  startTimeMinute: string;
  endTimeHour: string;
  endTimeMinute: string;
}
export interface IDateRangeInterface {
  id?: string;
  title?: string;
}
export interface IDateOption {
  day: string;
  month: string;
  year: string;
}

export interface ERORSInterface {
  error_id: string;
}

const ShiftAddModalComponent: React.FC<IRotaAddModalProps> = (props) => {
  const cancelButtonRef = useRef(null);
  const navigate = useNavigate();
  // const dispatch = useAppDispatch();
  const [open, setOpen] = useState(false);
  const [flage, setFlage] = useState(false);
  const [isWeekOff, setIsWeekOff] = useState(false);
  const [addHockShift, setAddHockShift] = useState(false);
  const [modifiedArray, setModifiedArray] = useState([]);
  const [selectedShelDate, setSelectedShelDate] = useState<string | null>(null);

  const [calculatedStartTime, setCalculatedStartTime] = useState([]);

  const { isCreated, rotaCreationError, execute: createROTA } = useRotaCreateAPI();
  const { execute: standardShiftCreate, shiftId, setShiftId } = useRotaShiftCreateAPI();
  const fetchCliniRotaDetails = useRotaShiftFilterAPI();
  const fetchRotaShiftNameAPI = useRotaShiftNameAPI();
  const userLogInfo = useAppSelector((state) => state.auth?.user?.email);
  const { execute: logAPI } = useClickLogAPI();

  const fetchErrorListAPI = useRotaErrorListAPI();
  // const fetchShiftListAPI = useRotaShiftListAPI();
  const [hovered, setHovered] = useState(false);
  const [shellDisable, setShellDisable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [shiftTimes, setShiftTimes] = useState([]);

  const arrayConstants = useArrayConstants();

  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ROTA", "id");
  const { routeState } = useRouteInfo(routeId);
  const { rotaShiftName, RotaFilter, rotaerrorIds } = routeState.state as IRotaState;

  const startTimeItem = arrayConstants.overBookingStartTimeItems as ISelectMenuItemData[];

  const startTimeMinuteItem = arrayConstants.overBookingStartTimeMinuteItems as ISelectMenuItemData[];

  const shiftItems = useSelectMenuReducer(rotaShiftName, "shift_data_transformed", "id");

  const handelReapetDates = () => {
    const selectedDate = props?.dateRange?.find((d: any) => d.title === props?.shellDetails) as IDateRangeInterface;

    const clickDate = selectedDate?.id;
    setSelectedShelDate(clickDate);

    const generateDateArray = (days) => {
      const modified = [];
      for (let i = 1; i <= days; i++) {
        const nextDay = new Date(clickDate);
        nextDay.setDate(nextDay.getDate() + i);

        const formattedDate = `${nextDay.getDate().toString().padStart(2, "0")}-${(nextDay.getMonth() + 1).toString().padStart(2, "0")}-${nextDay.getFullYear()}`;
        modified.push({
          title: formattedDate,
          id: `${nextDay.getFullYear()}-${(nextDay.getMonth() + 1).toString().padStart(2, "0")}-${nextDay.getDate().toString().padStart(2, "0")}`,
        });
      }
      return modified;
    };

    const sevenDaysArray = generateDateArray(6);
    const fifteenDaysArray = generateDateArray(14);
    const thirtyDaysArray = generateDateArray(29);

    const endDates = {
      sevenDays: sevenDaysArray[sevenDaysArray.length - 1].title,
      fifteenDays: fifteenDaysArray[fifteenDaysArray.length - 1].title,
      thirtyDays: thirtyDaysArray[thirtyDaysArray.length - 1].title,
    };

    const dateRanges = [
      { label: `7 Days (till ${endDates.sevenDays})`, data: sevenDaysArray },
      { label: `15 Days (till ${endDates.fifteenDays})`, data: fifteenDaysArray },
      { label: `30 Days (till ${endDates.thirtyDays})`, data: thirtyDaysArray },
    ];

    // Setting the modified array with all date ranges
    setModifiedArray(dateRanges);

    fetchRotaShiftNameAPI();
  };

  const dateRangeItems = useSelectMenuReducer(modifiedArray, "label", "data");

  const formHook = useForm<IBookingCommentsFormFields>({
    mode: "onChange",
    defaultValues: {},
  });

  const handleCheckboxChange = () => {
    setIsWeekOff(!isWeekOff);
  };

  const handleAddTime = () => {
    setFlage(true);
    const form_data = formHook.getValues();
    setShiftTimes((prevTimes) => [
      ...prevTimes,
      {
        startTimeHour: form_data.startTimeHour,
        startTimeMinute: form_data.startTimeMinute,
        endTimeHour: form_data.endTimeHour,
        endTimeMinute: form_data.endTimeMinute,
      },
    ]);

    formHook.setValue("startTimeHour", form_data.endTimeHour);
    formHook.setValue("startTimeMinute", form_data.endTimeMinute);
    formHook.setValue("endTimeHour", "");
    formHook.setValue("endTimeMinute", "");
  };

  useEffect(() => {
    const form_data = formHook.getValues();
    if (form_data?.startTimeHour && flage) {
      const startTime = parseInt(form_data?.startTimeHour); // Convert to integer
      const filteredData = startTimeItem?.filter((item) => parseInt(item.id) >= startTime);
      setCalculatedStartTime(filteredData);
    } else {
      const filteredData = startTimeItem?.filter((item) => parseInt(item.id) >= 0);
      setCalculatedStartTime(filteredData);
    }
  }, [formHook.watch("endTimeMinute")]);

  const handleRemoveTime = (index) => {
    setShiftTimes((prevTimes) => prevTimes.filter((_, i) => i !== index));
    formHook.setValue("startTimeHour", "");
    formHook.setValue("startTimeMinute", "");
    setCalculatedStartTime(startTimeItem);
  };

  const createShiftAdHok = () => {
    const form_data = formHook.getValues();

    let constructedBody: IRotaManagementShiftListData = {
      shift_name: "Adhoc Shift",
      shift_timings: null,
      shift_status: true,
      shift_type: "adhoc",
    };
    if (flage) {
      constructedBody = {
        ...constructedBody,
        shift_timings: [
          ...shiftTimes.map(({ startTimeHour, startTimeMinute, endTimeHour, endTimeMinute }) => {
            return {
              start_time: `${startTimeHour}:${startTimeMinute}`,
              end_time: `${endTimeHour}:${endTimeMinute}`,
            };
          }),
          // Append additional object if form_data.endTimeHour is available
          form_data.endTimeHour &&
            (() => {
              return {
                start_time: `${form_data.startTimeHour}:${form_data.startTimeMinute}`,
                end_time: `${form_data.endTimeHour}:${form_data.endTimeMinute}`,
              };
            })(),
        ].filter(Boolean), // Remove any potential undefined values
      };
    } else {
      constructedBody = {
        ...constructedBody,
        shift_timings: [
          {
            start_time: `${form_data.startTimeHour}:${form_data.startTimeMinute}`,
            end_time: `${form_data.endTimeHour}:${form_data.endTimeMinute}`,
          },
        ],
      };
    }

    standardShiftCreate(constructedBody);
  };

  useEffect(() => {
    if (shiftId) {
      const form_data = formHook.getValues();
      const dates = form_data.date;
      const rotaDateSet = new Set(dates ? [...dates, selectedShelDate] : [selectedShelDate]);
      const rotaDate = Array?.from(rotaDateSet);

      const constructedBody: IRotaManagementRotaCreatePropsData = {
        clinic_id: props?.clinicId?.clinic_id,
        staff_id: props?.stafDetails?.staff_id,
        rota_dates: rotaDate,
        shift_id: shiftId,
        is_week_off: isWeekOff ? true : false,
      };
      createROTA(constructedBody).then(async (response) => {
        if (response.status) {
          setOpen(false);
          await fetchCliniRotaDetails(RotaFilter);
          await setShiftId(null);
          await setAddHockShift(false);
        } else {
          setOpen(true);
        }
      });
    }
  }, [shiftId]);

  const callBack = () => {
    setAddHockShift(true);
    formHook.setValue("shift", null);
  };

  const handelClick = () => {
    if (isSubmitting) return;
    if (addHockShift) {
      //
      createShiftAdHok();
    } else {
      setIsSubmitting(true);
      const form_data = formHook.getValues();
      const dates = Array.isArray(form_data.date) ? form_data.date.map((item) => item.id) : []; // Fallback to an empty array if form_data.date is not an array

      const rotaDateSet = new Set(dates ? [...dates, selectedShelDate] : [selectedShelDate]);
      const rotaDate = Array?.from(rotaDateSet);

      const constructedBody: IRotaManagementRotaCreatePropsData = {
        clinic_id: props?.clinicId?.clinic_id,
        staff_id: props?.stafDetails?.staff_id,
        rota_dates: rotaDate,
        shift_id: isWeekOff ? "65b8a8f11c6793646f847e9b" : form_data?.shift,
        is_week_off: isWeekOff ? true : false,
      };
      createROTA(constructedBody)
        .then(() => {
          setOpen(true);
          const logBody: IClickLogBody = {
            event_type: "ROTA_INSERT",
            clinic_id: props?.clinicId?.clinic_id,
            staff_id: props?.stafDetails?.staff_id,
            shift_id: isWeekOff ? "65b8a8f11c6793646f847e9b" : form_data?.shift,
            vms_user_id: userLogInfo,
            scr_id: "ROTA",
            timestamp: Date.now(),
          };
          logAPI(logBody);
          // setaddRotaError(null);
        })
        .finally(() => setIsSubmitting(false));
    }
  };

  useAfterFirstRender(() => {
    if (isCreated === "CREATED") {
      setOpen(false);
      fetchCliniRotaDetails(RotaFilter);
    }
  }, [isCreated]);

  const handelPermisionButton = () => {
    const form_data = formHook.getValues();
    if (form_data.shift || isWeekOff) {
      return false;
    } else {
      return true;
    }
  };
  const handelPermisionButtonAdhok = () => {
    const form_data = formHook.getValues();
    if (form_data.startTimeHour && form_data.startTimeMinute && form_data.endTimeHour && form_data.endTimeMinute) {
      return false;
    } else if (shiftTimes?.length >= 1) {
      return false;
    } else {
      return true;
    }
  };

  const handelPermisionButtonAdhokAdd = () => {
    const form_data = formHook.getValues();
    if (form_data.startTimeHour && form_data.startTimeMinute && form_data.endTimeHour && form_data.endTimeMinute) {
      return false;
    } else {
      return true;
    }
  };

  // form_data.date) ||

  const handelErrorList = () => {
    const errorId = rotaerrorIds?.data?.error_id as string;

    const constructedBody: ERORSInterface = {
      error_id: errorId,
    };
    fetchErrorListAPI(constructedBody);
    navigate(`/app/rota/rota-error`);
  };

  function formatDate(dateString) {
    const date = new Date(dateString?.id);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const year = date.getFullYear().toString().slice(-2);
    const month = months[date.getMonth()];
    const day = date.getDate();
    return `${day}${getOrdinalSuffix(day)} ${month} '${year}`;
  }

  // Function to get the ordinal suffix for a number
  function getOrdinalSuffix(number) {
    if (number >= 11 && number <= 13) {
      return "th";
    }
    const lastDigit = number % 10;
    switch (lastDigit) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  // Function to get the ordinal suffix for a number

  const selectedShell = () => {
    const dates = props?.dateRange;
    const selectedDate = dates?.find((d: any) => d.title === props?.shellDetails);
    if (selectedDate) {
      return formatDate(selectedDate);
    }
  };

  const handelOpenModal = () => {
    const dates = props?.dateRange;
    const selectedDate = dates?.find((d: any) => d.title === props?.shellDetails) as IDateRangeInterface;
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    const selectedShellDate = selectedDate?.id;
    const providedDate = new Date(selectedShellDate);
    if (providedDate > today) {
      setOpen(true);
      handelReapetDates();
      setShellDisable(false);
    } else {
      setShellDisable(true);
    }
  };

  const handelOpenHoverModal = () => {
    const dates = props?.dateRange;
    const selectedDate = dates?.find((d: any) => d.title === props?.shellDetails) as IDateRangeInterface;
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    const selectedShellDate = selectedDate?.id;
    const providedDate = new Date(selectedShellDate);
    if (providedDate > today) {
      setShellDisable(false);
    } else {
      setShellDisable(true);
    }
  };

  useEffect(() => {
    if (shiftTimes?.length === 0) {
      setFlage(false);
    }
  }, [shiftTimes]);

  useEffect(() => {
    if (isWeekOff) {
      setAddHockShift(false);
    } else {
      //
      formHook.setValue("shift", null);
    }
  }, [isWeekOff]);

  return (
    <div>
      <div>
        <span
          onClick={() => {
            handelOpenModal();
          }}
          className={` ${hovered ? "bg-[#f0f5fc]" : ""}  ${shellDisable ? "cursor-not-allowed" : "cursor-pointer"}  text-center h-16 border border-slate-100 flex justify-center items-center`}
          onMouseEnter={() => {
            handelOpenHoverModal();
            setHovered(true);
          }}
          onMouseLeave={() => setHovered(false)}
        >
          {hovered && !shellDisable ? <PlusIcon className="w-4 h-4" /> : ""}
        </span>
      </div>

      <Transition.Root show={open} as={Fragment}>
        <Dialog
          as="div"
          className="z-50 fixed inset-0 overflow-y-auto"
          initialFocus={cancelButtonRef}
          onClose={() => setOpen(false)}
        >
          <div className="sm:block flex justify-center items-end px-4 sm:p-0 pt-4 pb-20 min-h-screen text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span className="sm:inline-block hidden sm:align-middle sm:h-screen" aria-hidden="true">
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white shadow-xl sm:my-8 rounded-lg sm:w-full sm:max-w-[45rem] text-left transform transition-all overflow-visible sm:align-middle">
                <div className="bg-white px-4 sm:p-6 pt-5 pb-4 sm:pb-4">
                  <h3 className="flex justify-between mb-1 font-medium text-[#000] text-sm">
                    <span className="flex flex-col text-xs">
                      {" "}
                      Add Schedule <span className="text-[#808DA0] text-xs">{selectedShell()}</span>
                    </span>

                    <span
                      className="ml-6 cursor-pointer"
                      onClick={() => {
                        setOpen(false);
                        setAddHockShift(false);
                        setIsWeekOff(false);
                      }}
                    >
                      <XMarkIcon className="w-4 h-4" />
                    </span>
                  </h3>
                  <hr className="mt-3" />

                  <div>
                    <div className="flex gap-2 my-5">
                      <input
                        type="checkbox"
                        checked={isWeekOff}
                        onChange={handleCheckboxChange}
                        className="border-gray-300 rounded-sm focus:ring-0 w-4 h-4 text-black"
                      />
                      <p>Week Off</p>
                    </div>

                    <div className="flex flex-col gap-7 mt-4">
                      <div className="flex items-center gap-6">
                        <h1 className="w-1/5 font-normal text-xs">Name</h1>
                        <div className="w-8/12 font-medium text-xs">{props?.stafDetails?.staff_name}</div>
                      </div>
                      <div className="flex items-center gap-6">
                        <h1 className="w-1/5 font-normal text-xs">Clinic</h1>
                        <div className="w-8/12 font-medium text-xs">{props?.clinicId?.clinic_name}</div>
                      </div>
                      {!isWeekOff && (
                        <div>
                          <div className="flex items-center gap-6">
                            <h1 className="w-1/5 font-normal text-xs">Shift Name</h1>
                            <div className="flex flex-col gap-4 w-8/12 font-medium text-xs">
                              {!addHockShift && (
                                <NonSearchableSelectMenu
                                  errorMessages={[{ message: "shift is required", type: "required" }]}
                                  onSelectItem={(item) => {
                                    if (item) {
                                      formHook.setValue("shift", item.id);
                                      setAddHockShift(false);
                                    }
                                  }}
                                  fieldError={formHook.formState.errors.shift}
                                  register={formHook.register("shift", { required: true })}
                                  selectItems={shiftItems ?? []}
                                  placeholder="Select Shift"
                                  showTooltips={false}
                                  showTypedErrors={false}
                                  showDropdownIcon={true}
                                  addAction={{ title: "+ Create Adhoc Shift", callBack }}
                                  defaultSelected={shiftItems?.filter((oc) => oc.title === formHook.watch("shift"))[0]}
                                  listBoxClassName="w-full"
                                  className="text-gray-800"
                                  containerClassName="w-full"
                                />
                              )}
                              {addHockShift && (
                                <div className="flex flex-col">
                                  <div className="grid grid-cols-2">
                                    <p className="font-medium">Start Time</p>
                                    <p className="font-medium">End Time</p>
                                  </div>

                                  {shiftTimes?.length > 0 && (
                                    <ShiftBreakComponent shiftTimes={shiftTimes} handleRemoveTime={handleRemoveTime} />
                                  )}
                                  <div className="flex items-center gap-3">
                                    <div className="gap-5 grid grid-cols-2">
                                      <div className="gap-3 grid grid-cols-2 mt-3">
                                        <NonSearchableSelectMenu
                                          errorMessages={[{ message: "shift is required", type: "required" }]}
                                          onSelectItem={(item) => {
                                            if (item) {
                                              formHook.setValue("startTimeHour", item.title);
                                            }
                                          }}
                                          fieldError={formHook.formState.errors.shift}
                                          register={formHook.register("startTimeHour", { required: true })}
                                          selectItems={calculatedStartTime ?? []}
                                          placeholder="HH"
                                          showTooltips={false}
                                          showTypedErrors={false}
                                          showDropdownIcon={true}
                                          defaultSelected={
                                            calculatedStartTime?.filter(
                                              (oc) => oc.title === formHook.watch("startTimeHour"),
                                            )[0]
                                          }
                                          listBoxClassName="w-full"
                                          className="text-gray-800"
                                          containerClassName="w-full"
                                        />
                                        <NonSearchableSelectMenu
                                          errorMessages={[{ message: "shift is required", type: "required" }]}
                                          onSelectItem={(item) => {
                                            if (item) {
                                              formHook.setValue("startTimeMinute", item.title);
                                            }
                                          }}
                                          fieldError={formHook.formState.errors.shift}
                                          register={formHook.register("startTimeMinute", { required: true })}
                                          selectItems={startTimeMinuteItem ?? []}
                                          placeholder="MM"
                                          showTooltips={false}
                                          showTypedErrors={false}
                                          showDropdownIcon={true}
                                          defaultSelected={
                                            startTimeMinuteItem?.filter(
                                              (oc) => oc.title === formHook.watch("startTimeMinute"),
                                            )[0]
                                          }
                                          listBoxClassName="w-full"
                                          className="text-gray-800"
                                          containerClassName="w-full"
                                        />
                                      </div>

                                      <div className="items-center gap-3 grid grid-cols-2 mt-2">
                                        <NonSearchableSelectMenu
                                          errorMessages={[{ message: "shift is required", type: "required" }]}
                                          onSelectItem={(item) => {
                                            if (item) {
                                              formHook.setValue("endTimeHour", item.title);
                                            }
                                          }}
                                          fieldError={formHook.formState.errors.shift}
                                          register={formHook.register("endTimeHour", { required: true })}
                                          selectItems={startTimeItem ?? []}
                                          placeholder="HH"
                                          showTooltips={false}
                                          showTypedErrors={false}
                                          showDropdownIcon={true}
                                          defaultSelected={
                                            startTimeItem?.filter((oc) => oc.title === formHook.watch("endTimeHour"))[0]
                                          }
                                          listBoxClassName="w-full"
                                          className="text-gray-800"
                                          containerClassName="w-full"
                                        />
                                        <NonSearchableSelectMenu
                                          errorMessages={[{ message: "shift is required", type: "required" }]}
                                          onSelectItem={(item) => {
                                            if (item) {
                                              formHook.setValue("endTimeMinute", item.title);
                                            }
                                          }}
                                          fieldError={formHook.formState.errors.shift}
                                          register={formHook.register("endTimeMinute", { required: true })}
                                          selectItems={startTimeMinuteItem ?? []}
                                          placeholder="MM"
                                          showTooltips={false}
                                          showTypedErrors={false}
                                          showDropdownIcon={true}
                                          defaultSelected={
                                            startTimeMinuteItem?.filter(
                                              (oc) => oc.title === formHook.watch("endTimeMinute"),
                                            )[0]
                                          }
                                          listBoxClassName="w-full"
                                          className="text-gray-800"
                                          containerClassName="w-full"
                                        />
                                      </div>
                                    </div>
                                    <button
                                      disabled={handelPermisionButtonAdhokAdd()}
                                      className={`${!handelPermisionButtonAdhokAdd() ? "text-[#0068FF]" : "text-greay-500"} text-lg cursor-pointer mt-3`}
                                      onClick={handleAddTime}
                                    >
                                      +
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      {!isWeekOff && (
                        <div className="flex items-center gap-6">
                          <h1 className="w-1/5 text-xs">Repeats</h1>
                          <div className="w-8/12">
                            <NonSearchableSelectMenu
                              errorMessages={[{ message: "shift is required", type: "required" }]}
                              onSelectItem={(item) => {
                                if (item) {
                                  formHook.setValue("date", item.id);
                                }
                              }}
                              fieldError={formHook.formState.errors.shift}
                              register={formHook.register("date", { required: true })}
                              selectItems={dateRangeItems ?? []}
                              placeholder="Select Days"
                              showTooltips={false}
                              showDropdownIcon={true}
                              showTypedErrors={false}
                              defaultSelected={dateRangeItems?.filter((oc) => oc.id === formHook.watch("date"))[0]}
                              listBoxClassName="w-full"
                              className="text-gray-800"
                              containerClassName="w-full"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    {rotaCreationError && (
                      <p className="mt-5 text-red-500">
                        {rotaCreationError?.message}{" "}
                        <span
                          className="ml-4 font-medium text-blue-500 underline cursor-pointer"
                          onClick={handelErrorList}
                        >
                          View Error
                        </span>
                      </p>
                    )}

                    <div className="flex justify-end gap-4 mt-6">
                      <button
                        type="button"
                        onClick={() => {
                          setOpen(false);
                          setAddHockShift(false);

                          setIsWeekOff(false);
                        }}
                        className="inline-flex justify-center bg-gray-500 hover-bg-gray-50 mt-3 sm:mt-0 px-6 py-2 rounded-md ring-gray-300 ring-inset w-full sm:w-auto font-semibold text-white text-xs"
                      >
                        Cancel
                      </button>
                      {addHockShift ? (
                        <button
                          className={`rounded-md ${!handelPermisionButtonAdhok() && !isSubmitting ? "bg-[#193A6A]" : "bg-gray-400"} text-xs font-semibold text-white px-4 flex items-center gap-2`}
                          onClick={() => handelClick()}
                          disabled={handelPermisionButtonAdhok() || isSubmitting}
                          type="button"
                        >
                          {isSubmitting ? (
                            <>
                              <span className="animate-spin">
                                <BiLoaderAlt />
                              </span>
                              <span>Saving...</span>
                            </>
                          ) : (
                            <span>Save</span>
                          )}
                        </button>
                      ) : (
                        <button
                          className={`rounded-md ${!handelPermisionButton() && !isSubmitting ? "bg-[#193A6A]" : "bg-gray-400"} text-xs font-semibold text-white px-4 flex items-center gap-2`}
                          onClick={() => handelClick()}
                          disabled={handelPermisionButton() || isSubmitting}
                          type="button"
                        >
                          {isSubmitting ? (
                            <>
                              <span className="animate-spin">
                                <BiLoaderAlt />
                              </span>
                              <span>Saving...</span>
                            </>
                          ) : (
                            <span>Save</span>
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default ShiftAddModalComponent;

//it is important for farther
// const currentDate = new Date();
// const todayDate = currentDate.toISOString().split("T")[0]; // Get today's date in yyyy-mm-dd format

// const getNextWeekDate = (date) => {
//   const nextWeekDate = new Date(date);
//   nextWeekDate.setDate(nextWeekDate.getDate() + 7); // Add 7 days to get next week
//   return nextWeekDate.toISOString().split("T")[0]; // Return in yyyy-mm-dd format
// };

// const updatedDates = dates.map((date) => {
//   const dateObject = new Date(date);
//   if (dateObject < currentDate && date !== todayDate) {
//     // If date is in the past and not today, replace it with corresponding date in next week
//     return getNextWeekDate(dateObject);
//   } else {
//     return date; // Keep the date unchanged if it's not in the past or today
//   }
// });
